export interface WalletConnectionError {
    title: string;
    message: string;
    requiresReload?: boolean;
}

/** Provider details are used for classification, never displayed to the user. */
export function getWalletConnectionError(error: unknown): WalletConnectionError {
    const details = typeof error === "object" && error !== null ? error : {};
    const code = "code" in details ? String(details.code) : "";
    const message =
        "message" in details && typeof details.message === "string"
            ? details.message.toLowerCase()
            : typeof error === "string"
              ? error.toLowerCase()
              : "";

    if (code === "4001" || /reject|denied|cancelled|canceled/.test(message)) {
        return {
            title: "Connection cancelled",
            message: "You did not approve the connection. Try again when you are ready."
        };
    }
    if (code === "-32002" || /already pending|request pending|already processing/.test(message)) {
        return {
            title: "Request already open",
            message: "Open your wallet and complete or cancel the existing request. Then try again."
        };
    }
    if (/timeout|timed out/.test(message)) {
        return {
            title: "Connection timed out",
            message: "Your wallet did not respond. Open your wallet, then try again."
        };
    }
    if (code === "4900" || /not found|not installed|not available|unavailable|does not support/.test(message)) {
        return {
            title: "Wallet unavailable",
            message: "Make sure your wallet is enabled for this site, then try again."
        };
    }
    return {
        title: "Could not connect",
        message: "Open your wallet and try again, or choose another wallet."
    };
}

export const WALLET_RESET_ERROR: WalletConnectionError = {
    title: "Could not reset connection",
    message: "Close the request in your wallet, then reload this page.",
    requiresReload: true
};
